var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4380_5690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 6.95524C9.19442 6.95524 8.5415 6.30232 8.5415 5.49691C8.5415 4.69149 9.19442 4.03857 9.99984 4.03857C10.8053 4.03857 11.4582 4.69149 11.4582 5.49691C11.4582 6.30232 10.8053 6.95524 9.99984 6.95524ZM9.99984 11.9552C9.19442 11.9552 8.5415 11.3023 8.5415 10.4969C8.5415 9.69149 9.19442 9.03857 9.99984 9.03857C10.8053 9.03857 11.4582 9.69149 11.4582 10.4969C11.4582 11.3023 10.8053 11.9552 9.99984 11.9552ZM8.5415 15.4969C8.5415 16.3023 9.19442 16.9552 9.99984 16.9552C10.8053 16.9552 11.4582 16.3023 11.4582 15.4969C11.4582 14.6915 10.8053 14.0386 9.99984 14.0386C9.19442 14.0386 8.5415 14.6915 8.5415 15.4969Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4380_5690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreicon);
export default __webpack_public_path__ + "static/media/more icon.278b5713d0e10575693fe56899b30620.svg";
export { ForwardRef as ReactComponent };